import { useStrictInstance } from '@funtech-int/rival-react';

import { rumManagerRef } from '../lib/rum';

export function useRumManager() {
    return useStrictInstance(rumManagerRef);
}
